// Percentage Calculator Tool — fast, client-side percentage calculators.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const percentageCalculatorTool: Tool = {
  id: "percentage-calculator",
  name: () => m.pct_tool_name(),
  description: () => m.pct_tool_description(),
  icon: "🧮",
  basePath: "/percentage-calculator",
  status: "stable",
  tags: ["calculator", "percentage", "math", "finance"],
  pages: [
    {
      name: () => m.pct_nav_basic(),
      path: "/percentage-calculator",
      description: () => m.pct_nav_basic_desc(),
      icon: "🧮",
    },
    {
      name: () => m.pct_nav_increase(),
      path: "/percentage-calculator/percentage-increase",
      description: () => m.pct_nav_increase_desc(),
      icon: "📈",
    },
    {
      name: () => m.pct_nav_decrease(),
      path: "/percentage-calculator/percentage-decrease",
      description: () => m.pct_nav_decrease_desc(),
      icon: "📉",
    },
    {
      name: () => m.pct_nav_change(),
      path: "/percentage-calculator/percentage-change",
      description: () => m.pct_nav_change_desc(),
      icon: "🔀",
    },
    {
      name: () => m.pct_nav_difference(),
      path: "/percentage-calculator/percentage-difference",
      description: () => m.pct_nav_difference_desc(),
      icon: "⚖️",
    },
    {
      name: () => m.pct_nav_tip(),
      path: "/percentage-calculator/tip-calculator",
      description: () => m.pct_nav_tip_desc(),
      icon: "🧾",
    },
    {
      name: () => m.pct_nav_discount(),
      path: "/percentage-calculator/discount-calculator",
      description: () => m.pct_nav_discount_desc(),
      icon: "🏷️",
    },
  ],
};
